import services from '../../services.json'

const state = services

export default {
  state
}
